import _ from 'lodash';
import config from '../config';
import { breakpointToDevice } from './breakpoints';
import pubSub from './pubSub';
import adConfigs from '../config/adConfig.json';

const { IS_SERVER, CONFIG_PROFILE } = config;
const profile = '381929:MTG_Play_HTML5_Live';
const env = (CONFIG_PROFILE === 'prod' || CONFIG_PROFILE === 'stage' || CONFIG_PROFILE === 'special') ? 'prod' : 'test';

const getSegmentParams = () => _.map(_.get(window, 'playStorage.data.tracking.segments'), segment => '&' + segment + '=1').join('');

const renderedAds = {
  units: {},

  get(id) {
    return id ? renderedAds.units[id] : renderedAds.units;
  },

  set(id, params) {
    renderedAds.units[id] = {
      processed: false,
      loaded: false,
      ...params,
    };
  },

  reset() {
    renderedAds.units = {};
  },

  delete(units) {
    _.forEach(units, (value, key) => {
      if (value.processed) {
        delete renderedAds.units[key];
      }
    });
  },

  allAdsLoaded() {
    return !_.some(renderedAds.units, { processed: true, loaded: false });
  },

  getEmptyUnits() {
    return _.reduce(renderedAds.units, (result, value, key) => {
      if (value.processed && !value.loaded) result[key] = value;
      return result;
    }, {});
  },
};

pubSub.subscribe('displayAdRendered', (id) => {
  renderedAds.set(id);
});

pubSub.subscribe('displayAdLoaded', (id) => {
  // Set rendered ad unit to 'loaded' when it publishes the 'displayAdLoaded' event
  if (renderedAds.get(id)) renderedAds.set(id, { processed: true, loaded: true });

  if (renderedAds.allAdsLoaded()) {
    renderedAds.delete(renderedAds.get());
  }
});

export function getAdUnitPackage(country, adType, breakpoint) {
  const adConfig = adConfigs[country];
  if (typeof adConfig === 'undefined' || typeof breakpoint === 'undefined') {
    throw new Error('adConfig or breakpoint not provided');
  }

  const device = breakpointToDevice(breakpoint);

  if (!device) return '';

  const adPackage = adConfig.adUnits[adType][device];

  if (typeof adPackage === 'undefined') return '';

  const slau = [];
  const cd = [];

  _.forEach(adPackage, (value, name) => {
    slau.push(name);

    _.forEach(value, (dimensions) => {
      cd.push(`${dimensions.width},${dimensions.height}`);
    });
  });

  return `ptgt=s&slau=${slau.join('|')}&cd=${cd.join('|')}`;
}

export function getMaxWidth(country, adType, breakpoint) {
  const adConfig = adConfigs[country];
  if (typeof adConfig === 'undefined' || typeof breakpoint === 'undefined') {
    throw new Error('adConfig or breakpoint not provided');
  }

  const device = breakpointToDevice(breakpoint);

  if (!device) return 0;

  const adPackage = adConfig.adUnits[adType][device];

  if (typeof adPackage === 'undefined') return 0;

  const widths = [];

  _.forEach(adPackage, (value) => {
    _.forEach(value, (dimensions) => {
      widths.push(dimensions.width);
    });
  });

  return _.max(widths);
}

const initAdRequest = {
  linkTag2(params) {
    if (IS_SERVER) return;

    const { adConfig, csid, sovSeed, articleSlug } = params;
    const scriptTag = document.getElementById('linkTag2');

    if (scriptTag) {
      scriptTag.parentElement.removeChild(scriptTag);
    }

    // This will create an async <script> to load the FreeWheel LinkTag2 js.
    const profilePath = 'MTG_Live';

    const segmentParams = getSegmentParams();

    const articleId = articleSlug ? `&viasport.article=${articleSlug}` : '';

    window._fw_linktag_params = {
      // allow page slot to be rescanned after a few ms, or disable if -1
      scan_delay: 0,
      allow_rescan_after: 3000,
      server: adConfig[env].server,
      network_id: adConfig[env].networkId,
      profile,
      other_global_params: `csid=${csid}`,
      key_values: `_fw_fss=_fw_search&sov_seed=${sovSeed}${segmentParams}${articleId}`,
    };

    const e = () => {
      if (document.addEventListener) document.removeEventListener('DOMContentLoaded', e, false);
      else window.detachEvent('onload', e);
      window._fw_page_ready = true;
    };

    if (document.addEventListener) document.addEventListener('DOMContentLoaded', e, false);
    else if (window.attachEvent) window.attachEvent('onload', e);

    const lt = document.createElement('script');
    lt.setAttribute('id', 'linkTag2');
    lt.type = 'text/javascript';
    lt.async = true;

    lt.src = `https://mssl.fwmrm.net/p/${profilePath}/LinkTag2.js`;

    const s = document.getElementsByTagName('script')[0];
    if (s) s.parentNode.insertBefore(lt, s);
  },

  activeSlot(params) {
    if (IS_SERVER) return;

    const { adConfig, adType, id, csid, breakpoint, sovSeed, articleSlug} = params;
    const scriptTag = document.getElementById('activeSlotScript');

    if (scriptTag) {
      scriptTag.parentElement.removeChild(scriptTag);
    }

    const segmentParams = getSegmentParams();

    const lt = document.createElement('script');
    lt.type = 'text/javascript';
    lt.setAttribute('id', 'activeSlotScript');
    lt.async = true;
    lt.src = `https://${adConfig[env].server}/ad/g/1?resp=smrx&crtp=ptiling&nw=${adConfig[env].networkId}&prof=${profile}&csid=${csid};_fw_fss=_fw_search&sov_seed=${sovSeed}${segmentParams}&viasport.article=${articleSlug};slid=${id}&${getAdUnitPackage(params.country, adType, breakpoint)}&flag=%2Bcmpn&prct=text%2Fhtml_lit_js_wc_nw`;

    const s = document.getElementsByTagName('script')[0];
    if (s) s.parentNode.insertBefore(lt, s);
  },
};

export function initAdSession(params) {
  const renderedAdUnits = _.cloneDeep(renderedAds.get());

  // Check if there are any rendered ad units
  if (!_.isEmpty(renderedAdUnits)) {
    // Set all currently rendered ad units to 'processed'
    _.forEach(renderedAdUnits, (value, key) => {
      renderedAds.set(key, { processed: true });
    });

    // Make ad request (linkTag2 or activeSlot)
    if (params.method) initAdRequest[params.method](params);

    setTimeout(() => {
      // Delete and disable ad units that haven't received an ad after 3s
      const emptyUnits = renderedAds.getEmptyUnits();

      if (!_.isEmpty(emptyUnits)) {
        pubSub.publish('disableAdUnits', emptyUnits);
        renderedAds.delete(emptyUnits);
      }
    }, 3000);
  }
}



// WEBPACK FOOTER //
// ./src/util/adUtils.js